import { useEffect } from 'react'
import { useSearchStore } from 'src/store/search'
import { Pagination, Card, Col, Button, Row, Tag } from 'antd'
import { PhotoProvider, PhotoView } from 'react-photo-view'
import { Preloader } from 'src/components/preloader'
import 'react-photo-view/dist/react-photo-view.css'
import { useParams } from 'react-router-dom'
import { USDollar } from 'src/utils'

export const Photo = () => {
  const { id } = useParams()

  const { onLoad, isLoading, detailsData, detailsPagination, onSearchDetails } =
    useSearchStore((store) => store)

  useEffect(() => {
    onLoad(id)
  }, [])

  return (
    <div>
      <h1>Photo</h1>
      <div style={{ position: 'relative', padding: '20px 0' }}>
        {isLoading ? <Preloader /> : null}
        {detailsData
          ? detailsData.map((photo) => (
              <Card key={photo?.id} style={{ margin: '10px 0' }}>
                <Row>
                  <Col
                    xs={24}
                    md={8}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'flex-start'
                    }}
                  >
                    <div>
                      <p style={{ marginBottom: 5 }}>
                        Owner email:{' '}
                        <Tag color='gold'>{photo?.owner?.data?.email || '-'}</Tag>
                      </p>
                      <p style={{ paddingBottom: 5 }}>
                        ID: <Tag color='red'>{photo?.id || '-'}</Tag>
                      </p>
                      <p style={{ paddingBottom: 5 }}>
                        Created at:{' '}
                        <Tag color='green'>
                          {photo?.readable_created_at || '-'}
                        </Tag>
                      </p>
                      <p style={{ paddingBottom: 5 }}>
                        Updated at:{' '}
                        <Tag color='cyan'>
                          {photo?.readable_updated_at || '-'}
                        </Tag>
                      </p>
                    </div>
                  </Col>
                  <Col
                    xs={24}
                    md={4}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'flex-start'
                    }}
                  >
                    <div>
                      <p style={{ marginBottom: 5 }}>
                        Status: <Tag color='lime'>{photo?.status || '-'}</Tag>
                      </p>
                      <p style={{ marginBottom: 5 }}>
                        Type: <Tag color='gold'>{photo?.type || '-'}</Tag>
                      </p>
                      <p style={{ marginBottom: 5 }}>
                        Price:{' '}
                        <Tag color='green'>
                          {photo?.price ? USDollar.format(photo?.price) : '-'}
                        </Tag>
                      </p>
                      <p style={{ marginBottom: 5 }}>
                        Category:{' '}
                        <Tag color='volcano'>
                          {photo?.category?.title || '-'}
                        </Tag>
                      </p>
                      <p style={{ marginBottom: 5 }}>
                        Favorites count:{' '}
                        <Tag color='gold'>
                          {photo?.favorites?.favorites_count || 0}
                        </Tag>
                      </p>
                    </div>
                  </Col>
                  <Col
                    xs={24}
                    md={6}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      flexDirection: 'column'
                    }}
                  >
                    <PhotoProvider>
                      <div>
                        {photo?.photos?.data.map((item) => (
                          <PhotoView key={item?.id} src={item?.photo}>
                            <img style={{ margin: 2 }} src={item.thumb_s} alt={item?.id} />
                          </PhotoView>
                        ))}
                      </div>
                    </PhotoProvider>
                  </Col>
                  <Col
                    xs={24}
                    md={6}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'flex-start'
                    }}
                  >
                    <div>
                      <p>
                        <b>Title:</b>
                      </p>
                      <p style={{ marginBottom: 10 }}>
                        <i>{photo?.title || '-'}</i>
                      </p>
                      <p>
                        <b>Description:</b>
                      </p>
                      <p>
                        <i>{photo?.description || '-'}</i>
                      </p>
                    </div>
                  </Col>
                </Row>
              </Card>
            ))
          : null}
      </div>
      {detailsPagination ? (
        <Pagination
          defaultCurrent={1}
          current={detailsPagination?.current_page}
          total={detailsPagination?.total}
          pageSize={detailsPagination?.per_page}
          onChange={(newPage) => onSearchDetails(id, newPage)}
          showTotal={(total, range) => `${range[0]}-${range[1]} of ${total}`}
        />
      ) : null}
    </div>
  )
}
